<main>
  <fr8bot-web-entity-home-section
    [videoSrc]="videos.customer"
    posterSrc="/assets/image/web-customer-video.webp"
  >
    <ng-container title>
      {{ 'landing.customers.home.title1' | translate }}
      <span class="web-title-highlight">{{
        'landing.customers.home.titleHighlight' | translate
      }}</span>
      {{ 'landing.customers.home.title2' | translate }}
    </ng-container>

    <ng-container description>
      {{ 'landing.customers.home.description' | translate }}
    </ng-container>

    <ng-container actions>
      <fr8bot-ui-button
        type="primaryCut"
        size="large"
        data-testid="landing-shippers-ship-now"
        (click)="landing.openAuthDialog(AUTH_CONTEXT.ShipLoadNow)"
      >
        {{ 'landing.customers.home.shipNow' | translate }}
        <fr8bot-ui-icon postfix-icon name="arrow-right-16" [size]="16" />
      </fr8bot-ui-button>

      <fr8bot-ui-button
        data-testid="landing-shippers-sign-up"
        (click)="landing.openCustomerCabinet()"
        type="secondary"
        size="large"
        >{{ 'landing.customers.home.signUpFree' | translate }}</fr8bot-ui-button
      >
    </ng-container>

    <ng-container label>{{ 'landing.customers.home.label' | translate }}</ng-container>
  </fr8bot-web-entity-home-section>

  <section class="web-purpose-build">
    <div class="web-purpose-build__inner">
      <div class="web-purpose-build__inner-head">
        <p class="web-section-label">{{ 'landing.customers.purposeBuild.label' | translate }}?</p>

        <h2 class="web-purpose-build__inner-head-title">
          {{ 'landing.customers.purposeBuild.titleStart' | translate }}
          <span class="web-title-highlight">{{
            'landing.customers.purposeBuild.titleHighlight' | translate
          }}</span>
          {{ 'landing.customers.purposeBuild.titleEnd' | translate }}
        </h2>
      </div>

      <div class="web-purpose-build__inner-body">
        <ng-template
          [ngTemplateOutlet]="purposeBuildCard"
          [ngTemplateOutletContext]="{
            src: '/assets/image/web-purpose-aircraft.webp',
            title: 'landing.customers.purposeBuild.cards.aircraft' | translate,
          }"
        />

        <ng-template
          [ngTemplateOutlet]="purposeBuildCard"
          [ngTemplateOutletContext]="{
            src: '/assets/image/web-purpose-production.webp',
            title: 'landing.customers.purposeBuild.cards.production' | translate,
          }"
        />

        <ng-template
          [ngTemplateOutlet]="purposeBuildCard"
          [ngTemplateOutletContext]="{
            src: '/assets/image/web-purpose-hours.webp',
            title: 'landing.customers.purposeBuild.cards.booth' | translate,
          }"
        />

        <ng-template
          [ngTemplateOutlet]="purposeBuildCard"
          [ngTemplateOutletContext]="{
            src: '/assets/image/web-purpose-hospital.webp',
            title: 'landing.customers.purposeBuild.cards.hospital' | translate,
          }"
        />
      </div>
    </div>
  </section>

  <section class="web-everything-need">
    <div class="web-everything-need__gradient"></div>

    <div class="web-everything-need__inner">
      <div class="web-everything-need__inner-head">
        <p class="web-section-label">
          {{ 'landing.customers.everythingNeed.label' | translate }}
        </p>
        <h2 class="web-everything-need__inner-head-title">
          {{ 'landing.customers.everythingNeed.title' | translate }}
        </h2>
      </div>

      <div class="web-everything-need__inner-body">
        <div class="web-everything-need__inner-body-cards">
          <ng-template
            [ngTemplateOutlet]="everythingNeedCard"
            [ngTemplateOutletContext]="{
              title: 'landing.customers.everythingNeed.cards.liveCapacity.title' | translate,
              description:
                'landing.customers.everythingNeed.cards.liveCapacity.description' | translate,
            }"
          ></ng-template>

          <ng-template
            [ngTemplateOutlet]="everythingNeedCard"
            [ngTemplateOutletContext]="{
              title: 'landing.customers.everythingNeed.cards.booking.title' | translate,
              description: 'landing.customers.everythingNeed.cards.booking.description' | translate,
            }"
          ></ng-template>

          <ng-template
            [ngTemplateOutlet]="everythingNeedCard"
            [ngTemplateOutletContext]="{
              title: 'landing.customers.everythingNeed.cards.documentation.title' | translate,
              description:
                'landing.customers.everythingNeed.cards.documentation.description' | translate,
            }"
          ></ng-template>

          <ng-template
            [ngTemplateOutlet]="everythingNeedCard"
            [ngTemplateOutletContext]="{
              title: 'landing.customers.everythingNeed.cards.tsaTwic.title' | translate,
              description: 'landing.customers.everythingNeed.cards.tsaTwic.description' | translate,
            }"
          ></ng-template>

          <ng-template
            [ngTemplateOutlet]="everythingNeedCard"
            [ngTemplateOutletContext]="{
              title: 'landing.customers.everythingNeed.cards.pricing.title' | translate,
              description: 'landing.customers.everythingNeed.cards.pricing.description' | translate,
            }"
          ></ng-template>

          <ng-template
            [ngTemplateOutlet]="everythingNeedCard"
            [ngTemplateOutletContext]="{
              title: 'landing.customers.everythingNeed.cards.tracking.title' | translate,
              description:
                'landing.customers.everythingNeed.cards.tracking.description' | translate,
            }"
          ></ng-template>

          <ng-template
            [ngTemplateOutlet]="everythingNeedCard"
            [ngTemplateOutletContext]="{
              title: 'landing.customers.everythingNeed.cards.alerts.title' | translate,
              description: 'landing.customers.everythingNeed.cards.alerts.description' | translate,
            }"
          ></ng-template>

          <ng-template
            [ngTemplateOutlet]="everythingNeedCard"
            [ngTemplateOutletContext]="{
              title: 'landing.customers.everythingNeed.cards.api.title' | translate,
              description: 'landing.customers.everythingNeed.cards.api.description' | translate,
            }"
          ></ng-template>
        </div>

        <fr8bot-ui-button
          type="primaryCut"
          size="large"
          class="web-everything-need__inner-body-actions"
          data-testid="landing-shippers-everything-cta"
          (click)="landing.openCustomerCabinet()"
        >
          {{ 'landing.customers.everythingNeed.button' | translate }}
          <fr8bot-ui-icon postfix-icon name="arrow-right-16" [size]="16" />
        </fr8bot-ui-button>
      </div>
    </div>
  </section>

  <fr8bot-web-parallax-bg>
    <div class="trapeze trapeze--top"></div>
    <div class="web-section-shadow"></div>

    <div class="live-capacity-section">
      <div class="live-capacity-section__header">
        <span class="web-section-label">{{ 'landing.customers.whatMoves.label' | translate }}</span>

        <h2 class="live-capacity-section__header-title">
          {{ 'landing.customers.whatMoves.title' | translate }}
        </h2>
      </div>

      <div class="live-capacity-section__content">
        <div class="live-capacity-section__content-cards">
          <fr8bot-web-card-v-1
            [title]="'landing.customers.whatMoves.cards.aviation.title' | translate"
            [description]="'landing.customers.whatMoves.cards.aviation.description' | translate"
            icon="web-plane"
          />

          <fr8bot-web-card-v-1
            [title]="'landing.customers.whatMoves.cards.pharma.title' | translate"
            [description]="'landing.customers.whatMoves.cards.pharma.description' | translate"
            icon="web-pharma"
          />

          <fr8bot-web-card-v-1
            [title]="'landing.customers.whatMoves.cards.manufacturing.title' | translate"
            [description]="
              'landing.customers.whatMoves.cards.manufacturing.description' | translate
            "
            icon="web-manufactory"
          />

          <fr8bot-web-card-v-1
            [title]="'landing.customers.whatMoves.cards.agriculture.title' | translate"
            [description]="'landing.customers.whatMoves.cards.agriculture.description' | translate"
            icon="web-agro"
          />

          <fr8bot-web-card-v-1
            [title]="'landing.customers.whatMoves.cards.events.title' | translate"
            [description]="'landing.customers.whatMoves.cards.events.description' | translate"
            icon="web-stage"
          />

          <fr8bot-web-card-v-1
            [title]="'landing.customers.whatMoves.cards.automotive.title' | translate"
            [description]="'landing.customers.whatMoves.cards.automotive.description' | translate"
            icon="web-car"
          />

          <fr8bot-web-card-v-1
            [title]="'landing.customers.whatMoves.cards.retail.title' | translate"
            [description]="'landing.customers.whatMoves.cards.retail.description' | translate"
            icon="web-wirehouse"
          />

          <fr8bot-web-card-v-1
            [title]="'landing.customers.whatMoves.cards.airport.title' | translate"
            [description]="'landing.customers.whatMoves.cards.airport.description' | translate"
            icon="web-aero-docs"
          />
        </div>
      </div>
    </div>
  </fr8bot-web-parallax-bg>

  <fr8bot-web-about-section
    [videoSrc]="videos.trafficBlack"
    posterSrc="/assets/image/web-traffic-black.webp"
    (shipNow)="landing.openAuthDialog(AUTH_CONTEXT.ShipLoadNow)"
  >
    <div class="trapeze trapeze--top"></div>

    <ng-container label>{{ 'landing.customers.trust.label' | translate }}</ng-container>

    <ng-container title> {{ 'landing.customers.trust.title' | translate }}. </ng-container>

    <ng-container description>
      <p>{{ 'landing.customers.trust.p1' | translate }}</p>
      <p>{{ 'landing.customers.trust.p2' | translate }}</p>
    </ng-container>

    <div actions class="tw:mt-2.5 tw:flex tw:flex-col">
      @if (!servicesExpanded()) {
        <fr8bot-ui-button
          type="secondary"
          size="large"
          class="tw:w-70"
          data-testid="landing-shippers-see-more"
          [attr.aria-controls]="SERVICES_ID"
          aria-expanded="false"
          (click)="expandServices()"
        >
          {{ 'landing.customers.trust.seeMore' | translate }}
          <fr8bot-ui-icon postfix-icon name="arrow-down-16" [size]="16" />
        </fr8bot-ui-button>
      }

      <!--
        FR8BOT-1254: legal copy for a USPTO trademark filing. Keep it verbatim, in English, outside
        i18n and always rendered (it must be in the prerendered page source) — collapsed by CSS,
        never by `@if`. Do not edit this copy without clearing it with the trademark owner.
      -->
      <section
        class="web-services"
        [class.web-services--expanded]="servicesExpanded()"
        [class.web-services--animated]="servicesOpened()"
        [class.web-services--booted]="booted()"
        [id]="SERVICES_ID"
        [attr.inert]="servicesExpanded() ? null : ''"
      >
        <div class="web-services__clip">
          <div class="web-services__inner">
            <h3 class="web-services__title">How FR8BOT Handles Your Freight</h3>

            <p>
              FR8BOT is the freight services company behind every load moved through this site.
              FR8BOT prices the load, negotiates the contract, reserves the capacity, plans the
              route, and keeps the shipper informed through delivery.
            </p>

            <p class="web-services__item">
              <strong>FR8BOT negotiates your trucking contracts.</strong> FR8BOT facilitates
              negotiations of business contracts between shippers and carriers in the trucking
              industry. For each load, FR8BOT calculates a recommended rate and suggests key
              contract terms, including accessorial charges, waiting and detention provisions,
              pickup and delivery windows, and insurance requirements. It then facilitates the
              negotiation process between the shipper and carrier and helps generate a
              transportation contract reflecting the agreed terms and ready for signature. This
              allows shippers to avoid negotiating each contract directly with the carrier while
              FR8BOT supports and streamlines the negotiation process.
            </p>
            <p class="web-services__item">
              <strong>FR8BOT books and reserves your transportation online.</strong> FR8BOT provides
              transportation reservation services and online transportation reservation services.
              FR8BOT shows live available capacity in any market — by radius, vehicle type, and date
              — and shippers access, reserve, and book that capacity directly through FR8BOT. FR8BOT
              confirms the reservation, issues the load confirmation, and assigns the vehicle to the
              shipment.
            </p>
            <p class="web-services__item">
              <strong>FR8BOT tells you who is driving your load.</strong> FR8BOT provides
              information relating to vehicle-driving services. FR8BOT verifies each driver's
              licensing, insurance, vehicle inspection and dimensions, training, and TSA/TWIC
              certification, and gives the shipper the driver's identity, contact, and status
              information for the duration of the trip.
            </p>
            <p class="web-services__item">
              <strong>FR8BOT plans the route and watches the road.</strong> FR8BOT provides traffic
              information services. FR8BOT calculates the best route for each load and monitors
              traffic, congestion, road closures, weather, and construction along that route, and
              notifies the shipper of delays and reroutes while the load is in transit.
            </p>
            <p class="web-services__item">
              <strong>FR8BOT advises you on how to move your freight.</strong> FR8BOT provides
              transportation consulting services and advisory services relating to transport. FR8BOT
              advises shippers on vehicle and service selection, lane and network planning, rate
              benchmarking, carrier qualification and insurance compliance, and transportation
              regulatory requirements, including Hazmat and TSA/TWIC requirements.
            </p>
            <p class="web-services__item">
              <strong>FR8BOT promotes your listings online.</strong> FR8BOT provides electronic
              commerce services, namely, providing information about products via telecommunication
              networks for advertising and sales purposes. FR8BOT also provides search engine
              optimization for sales promotion and consulting services in the field of search engine
              optimization for sales promotion, publishing and optimizing its customers' product,
              load, and capacity listings so that they are found by buyers through online search.
            </p>
            <p class="web-services__item">
              <strong>Ship a load.</strong> Post a load and FR8BOT will price it, negotiate it,
              reserve it, and route it.
            </p>

            <fr8bot-ui-button
              type="primaryCut"
              size="large"
              class="tw:w-70 tw:max-[740px]:w-full"
              data-testid="landing-shippers-services-ship-now"
              (click)="landing.openCustomerCabinet()"
            >
              {{ 'landing.customers.services.shipNow' | translate }}
              <fr8bot-ui-icon postfix-icon name="arrow-right-16" [size]="16" />
            </fr8bot-ui-button>

            <div class="web-services__app">
              <h3 class="web-services__app-title">Get the FR8BOT App</h3>

              <p class="tw:text-center">
                Download the FR8BOT app for iPhone and Android. Post a load, get an instant FR8BOT
                rate, reserve a vehicle, and track your shipment from pickup to delivery — from
                anywhere.
              </p>

              <div class="web-services__app-stores">
                <fr8bot-web-logo class="tw:text-(--color-white__web)" />

                <div class="web-services__app-stores-list">
                  <div class="web-services__app-store">
                    <a
                      data-testid="landing-shippers-app-store"
                      target="_blank"
                      rel="noopener"
                      [href]="appStoreUrl"
                    >
                      <img
                        src="/assets/image/app-store-button.svg"
                        width="200"
                        height="67"
                        [alt]="'landing.customers.services.appStoreBadge' | translate"
                      />
                    </a>
                    <a
                      class="web-services__app-url"
                      target="_blank"
                      rel="noopener"
                      [href]="appStoreUrl"
                    >
                      @for (part of appStoreUrlParts; track $index) {
                        <wbr /><span>{{ part }}</span>
                      }
                    </a>
                  </div>

                  <div class="web-services__app-store">
                    <a
                      data-testid="landing-shippers-google-play"
                      target="_blank"
                      rel="noopener"
                      [href]="googlePlayUrl"
                    >
                      <img
                        src="/assets/image/google-play-button.svg"
                        width="200"
                        height="67"
                        [alt]="'landing.customers.services.googlePlayBadge' | translate"
                      />
                    </a>
                    <a
                      class="web-services__app-url"
                      target="_blank"
                      rel="noopener"
                      [href]="googlePlayUrl"
                    >
                      @for (part of googlePlayUrlParts; track $index) {
                        <wbr /><span>{{ part }}</span>
                      }
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </fr8bot-web-about-section>

  <div class="divider divider--size-large divider--color-black"></div>
</main>

<!---->
<!-- COMPONENTS -->
<!---->

<ng-template #purposeBuildCard let-src="src" let-title="title">
  <div class="purpose-build-card">
    <img [src]="src" alt="" />

    <div class="purpose-build-card__content">
      <div class="purpose-build-card__content-icon">
        <fr8bot-ui-icon name="alert-50" [size]="50" />
      </div>

      <h3 class="purpose-build-card__content-title" [innerHTML]="title"></h3>
    </div>
  </div>
</ng-template>

<ng-template #everythingNeedCard let-title="title" let-description="description">
  <div class="everything-need-card">
    <div class="everything-need-card__checkmark">
      <fr8bot-ui-checkmark-icon />
    </div>

    <div class="everything-need-card__content">
      <span class="everything-need-card__content-title">{{ title }}</span>
      <span class="everything-need-card__content-description"> {{ description }}</span>
    </div>
  </div>
</ng-template>
